import { OfferDiscountTypeEnumV2 } from '@redteclab/api/clients/bully'

import { getLegalSupNote } from 'views/components/organisms/Cart/ProductListCart/SellerPromotionBanner/GetSellerPromotionNotification'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

import { MarketPlaceFreeItemsDiscount } from './MarketPlaceFreeItemsDiscount'
import { MarketPlaceTotalAmountDiscount } from './MarketPlaceTotalAmountDiscount'
import { MarketPlaceTotalPercentageDiscount } from './MarketPlaceTotalPercentageDiscount'

interface MarketPlaceDiscountModalContentProps {
  discountConditionValue: string
  discountValue: string
  discountType: string
}

export const MarketPlaceDiscountModalContent = ({
  discountConditionValue,
  discountValue,
  discountType,
}: MarketPlaceDiscountModalContentProps) => {
  const { tenant } = usePublicConfig()
  const legalSufixTenantNumber = getLegalSupNote(tenant)

  if (discountType === OfferDiscountTypeEnumV2.FreeItems) {
    return (
      <MarketPlaceFreeItemsDiscount
        discountConditionValue={discountConditionValue}
        discountValue={discountValue}
        legalSufix={legalSufixTenantNumber}
      />
    )
  }

  if (discountType === OfferDiscountTypeEnumV2.TotalAmount) {
    return (
      <MarketPlaceTotalAmountDiscount
        discountConditionValue={discountConditionValue}
        discountValue={discountValue}
        legalSufix={legalSufixTenantNumber}
      />
    )
  }

  if (discountType === OfferDiscountTypeEnumV2.TotalPercent) {
    return (
      <MarketPlaceTotalPercentageDiscount
        discountConditionValue={discountConditionValue}
        discountValue={discountValue}
        legalSufix={legalSufixTenantNumber}
      />
    )
  }

  return null
}
